import { render } from "./BackOfficeServices.vue?vue&type=template&id=700197d4"
import script from "./BackOfficeServices.vue?vue&type=script&lang=js"
export * from "./BackOfficeServices.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__